import React                      from 'react' ;
import { Empty
       , Layout
       , Menu }                   from 'antd' ;
import { Observer }               from 'mobx-react' ;


import { TEXT
       , tr }                     from '../00_assets' ;
import { CTE }                    from '../01_core' ;
import { logout }                 from '../02_api' ;
import { MApp }                   from '../09_model_app' ;
import { CorporativeLogo
       , ModalConfirm
       , ProductLogo
       , SelectLang }             from '../10_ui' ;
import { UsersScreen }            from '../21_screen_users' ;
import { WorkgroupsScreen }       from '../22_screen_workgroups' ;
import { ClientsScreen }          from '../23_screen_clients' ;
import { JobsScreen }             from '../24_screen_jobs' ;
import { KeyMasteringScreen }      from '../25_screen_key_mastering' ;


import { MScreenMain }            from './01_screen_main_model' ;

export const MainScreen: React.FC = () =>
<Layout className="layout">
       <CorporativeHeader />
       <MainHeader />
       <MainContent />
</Layout>


const CorporativeHeader: React.FC = ( ) =>
{
  const on_logout = ( ) => ModalConfirm( logout, { icon: 'logout' } ) ;

  return <div className="corp-header ant-layout-header flex-row flex-align-center">
    <CorporativeLogo />
    <ProductLogo  className="ml-3" />
    <div className="flex-1" />
    <SelectLang style={{width: 62}}/>
    <span className="separator">|</span>
    <Menu
      theme="dark"
      mode="horizontal"
      className="d-inline-block"
      selectedKeys={ [ ] }
      style={{ lineHeight: '64px' }}
      onSelect={ on_logout }
    >
    <Menu.Item><Observer render={ ( ) => <span>{ tr( TEXT.UI_SING_OUT ) }</span> }/></Menu.Item>
    </Menu>
  </div>
}


const MainHeader: React.FC = ( ) =>
<Observer render={ ( ) =>
{
  const app   = MApp( )
      , model = MScreenMain.instance( )
      , menu_entries =
          [ /*{ text: TEXT.UI_MENU_WORKGROUPS, value: CTE.SCREEN.WORKGROUPS }
          , */app.is_admin? { text: TEXT.UI_MENU_USERS, value: CTE.SCREEN.USERS } : null
          , { text: TEXT.UI_MENU_CLIENTS, value: CTE.SCREEN.CLIENTS }
          , { text: TEXT.UI_MENU_JOBS, value: CTE.SCREEN.JOBS }
          , { text: TEXT.UI_MENU_KEY_MASTERING, value: CTE.SCREEN.KEY_MASTERING }
          ].filter( a => a !== null ) as Array< { text: TEXT, value: any } > ;

  return <Layout.Header>
    <Menu
      theme="dark"
      mode="horizontal"
      selectedKeys={[ app.cur_page.name ]}
      style={{ lineHeight: '64px' }}
      onSelect={ model.on_select_menu }
    >
        {
          menu_entries.map( entry =>
            <Menu.Item key={ entry.value }>{ tr( entry.text ) }</Menu.Item> )
        }
    </Menu>
  </Layout.Header> ;
} } />


const MainContent: React.FC = ( ) =>
<Observer render={ ( ) =>
{
  const app  = MApp( )
      , page = app.cur_page.name ;

  return page === CTE.SCREEN.WORKGROUPS  ? <WorkgroupsScreen />
       : page === CTE.SCREEN.CLIENTS     ? <ClientsScreen />
       : page === CTE.SCREEN.JOBS        ? <JobsScreen />
       : page === CTE.SCREEN.KEY_MASTERING? <KeyMasteringScreen />
       : page === CTE.SCREEN.USERS && app.is_admin? <UsersScreen />
       : <div className="flex-row flex-align-center flex-justify-center flex-1">
          <Empty description={ tr( TEXT.PAGE_NOT_FOUND ) } />
         </div>
} } />

